import { BUILD_VERSION } from "../versioning/version";

/**
 * Detect the client platform (app channel).
 * @returns {string} win | mac | linux | ios | android | web
 */
export const detectClientPlatform = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isElectron = window.navigator.userAgent.indexOf("Electron") !== -1;

  if (isElectron && BUILD_VERSION?.platform) {
    return BUILD_VERSION.platform;
  }

  if (isElectron) {
    if (userAgent.indexOf("win") !== -1) return "win";
    if (userAgent.indexOf("mac") !== -1) return "mac";
    return "linux";
  }

  if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipad") !== -1)
    return "ios";
  if (userAgent.indexOf("android") !== -1) return "android";

  return "web";
};
